module.exports = __webpack_public_path__ + "static/img/wchart.b4af5ea3.png";